<template>
    <div class="bookend-footer mt-auto">
        <div class="trust-marks text-center px-3 py-4">
            <h1>{{$t('common.bookend.trustmarkHeader')}}</h1>
            <div class="lead">
                {{$t('common.bookend.trustmarkInformation')}}
            </div>
            <div class="row justify-content-center g-0">
                <div class="col-auto">
                    <a :href="$config.urls.arc" target="_blank" rel="noopener noreferrer">
                        <img src="@/assets/images/trustmarks/arc.png" alt="ARC" class="m-4" />
                    </a>
                </div>
                <div class="col-auto">
                    <a :href="$config.urls.iata" target="_blank" rel="noopener noreferrer">
                        <img src="@/assets/images/trustmarks/iata.png" alt="IATA" class="m-4" />
                    </a>
                </div>
                <div class="col-auto">
                    <a :href="$config.urls.worldpay" target="_blank" rel="noopener noreferrer">
                        <img src="@/assets/images/trustmarks/worldpay.png" alt="Worldpay from FIS" class="m-4" />
                    </a>
                </div>
                <div class="col-auto">
                    <a :href="$config.urls.cybersource" target="_blank" rel="noopener noreferrer">
                        <img src="@/assets/images/trustmarks/cybersource.png" alt="Cybersource" class="m-4" />
                    </a>
                </div>
            </div>
        </div>
        <div class="links row justify-content-center g-0">
            <div class="col-sm-auto text-center py-1">
                <a :href="$config.urls.terms" class="px-3 text-nowrap">
                    {{$t('common.bookend.termsConditions')}}
                </a>
            </div>
            <div class="last-link col-sm-auto text-center py-1">
                <a :href="$config.urls.privacy" class="px-3 text-nowrap">
                    {{$t('common.bookend.privacyPolicy')}}
                </a>
            </div>
            <div class="col-md-auto text-center py-1">
                <span class="px-3 text-nowrap">© {{year}} Pay For My Trip</span>
            </div>
            <locale-selector class="mt-3 text-white"/>
        </div>
    </div>
</template>

<script>
import LocaleSelector from "@/components/common/LocaleSelector";
export default {
    name: 'BookendFooter',
    components: {LocaleSelector},
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
};
</script>

<style lang="scss" scoped>
    $footerGradient: linear-gradient($dark, $secondary);
    $accentBorder: 7px solid $primary;

    .trust-marks {
        color: $dark;
        border-top: $accentBorder;
        border-bottom: $accentBorder;

        img {
            height: 3rem;
            -webkit-transition: opacity 0.15s ease-in-out 0s;
            transition: opacity 0.15s ease-in-out 0s;
            &:hover {
                opacity: 0.5;
            }
        }
    }

    .links {
        a, span {
            color: $white;
            font-size: 0.9rem;
        }
        a {
            color: $white;
            border-right: 1px solid $white;
            text-decoration: none;
            -webkit-transition: color 0.15s ease-in-out 0s;
            transition: color 0.15s ease-in-out 0s;
            &:hover {
                color: $gray-500;
            }
        }

        padding: 6rem 0;
        background: $footerGradient;
    }

    //Styles the small breakpoint and smaller.
    @include media-breakpoint-down(md) {
        .links .last-link a {
            border: 0;
        }
    }
    @include media-breakpoint-down(sm) {
        .links a {
            border: 0;
        }
    }
</style>